import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import tw from 'twin.macro';

const Box = styled.label`
  ${tw`flex items-start gap-2 text-sm cursor-pointer mb-3`}
`;

const Note = styled.p`
  ${tw`text-sm mb-3`}
  color: #b91c1c;
`;

/**
 * The versions a stay or service checkout is showing. The card form mounts only
 * after this box is ticked, so acceptance runs before the SetupIntent.
 */
export const CheckoutTerms: React.FC<{
  checked: boolean;
  onChange: (checked: boolean) => void;
  rentalHref?: string | null;
  includeCancellation?: boolean;
  outdatedMessage?: string | null;
}> = ({ checked, onChange, rentalHref, includeCancellation = false, outdatedMessage }) => (
  <div>
    <Box>
      <input
        type="checkbox"
        checked={checked}
        onChange={event => onChange(event.target.checked)}
        data-testid="checkout-terms"
      />
      <span>
        I agree to pay the total shown and to the{' '}
        {rentalHref && (
          <>
            <Link to={rentalHref}>rental agreement</Link>,{' '}
          </>
        )}
        <Link to="/policies/terms">terms of service</Link>
        {includeCancellation && (
          <>
            , <Link to="/policies/cancellation">cancellation policy</Link>
          </>
        )}{' '}
        and I acknowledge the <Link to="/policies/privacy">privacy policy</Link>.
      </span>
    </Box>
    {outdatedMessage && <Note role="alert">{outdatedMessage}</Note>}
  </div>
);
